export default "__VITE_ASSET__CpQdzu3l__"